module.exports = __webpack_public_path__ + "static/futurekey-06ee93dc90ab670a47b77102e50c6612.png";